import { useState } from 'react'
import { Patient } from '../types/patient'
import './PatientBulkActions.css'

interface PatientBulkActionsProps {
  selectedPatients: string[]
  onBulkMarkInactive: (ids: string[]) => Promise<void>
  onBulkExport: (patients: Patient[]) => void
  patients: Patient[]
}

export function PatientBulkActions({
  selectedPatients,
  onBulkMarkInactive,
  onBulkExport,
  patients,
}: PatientBulkActionsProps) {
  const [isProcessing, setIsProcessing] = useState(false)

  if (selectedPatients.length === 0) return null

  const selectedPatientData = patients.filter((p) => selectedPatients.includes(p.id))

  const handleBulkMarkInactive = async () => {
    if (
      !window.confirm(
        `Are you sure you want to mark ${selectedPatients.length} patient(s) as inactive?`
      )
    ) {
      return
    }

    setIsProcessing(true)
    try {
      await onBulkMarkInactive(selectedPatients)
    } catch (error) {
      alert('Failed to mark patients as inactive')
    } finally {
      setIsProcessing(false)
    }
  }

  const handleExport = () => {
    onBulkExport(selectedPatientData)
  }

  return (
    <div className="patient-bulk-actions">
      <div className="bulk-actions-info">
        <strong>{selectedPatients.length}</strong> patient(s) selected
      </div>
      <div className="bulk-actions-buttons">
        <button
          className="btn-bulk btn-export"
          onClick={handleExport}
          disabled={isProcessing}
        >
          Export Selected
        </button>
        <button
          className="btn-bulk btn-archive"
          onClick={handleBulkMarkInactive}
          disabled={isProcessing}
        >
          {isProcessing ? 'Marking Inactive...' : 'Mark Inactive Selected'}
        </button>
      </div>
    </div>
  )
}

